Jelly.Actions.Remove_Action_Input = function(Parameters)
{
	// Removes a input element from a reference.
	// TODO: should this be more abstract than action, or am I insane?
	// Parameters: Namespace, Element, Alias
	var Debug = false && Jelly.Debug.Debug_Mode;
	
	if (Debug)
	{
		Jelly.Debug.Group("Remove Action Input Element");
		Jelly.Debug.Log(Parameters);
	}
	
	// Lookup action reference
	var Action_Element = document.getElementById(Parameters["Namespace"]);
	var Action_Reference = Jelly.References.Get_Reference_For_Element(Action_Element);
	if (!Jelly.Actions.Is_Action_Reference(Action_Reference))
		return;
	
	// Verify input element
	if (Parameters["Element"]) { 
		var Input_Element = Parameters["Element"];
	}
	else if (Parameters["Alias"] && $("#" + Action_Element.id  + " input[name=" + Parameters["Alias"] +"]").length) {
		var Input_Element = $("#" + Action_Element.id  + " input[name=" + Parameters["Alias"] +"]").get(0);
	}
	else{
		Jelly.Debug.Display_Error("Trying to remove input from action reference by namespace, but input element is empty or not set");
		return;
	}
	
	// Verify input alias
	if (Parameters["Alias"])
		var Input_Alias = Parameters["Alias"];
	else
		var Input_Alias = Input_Element.name;
	if (!Input_Alias)
	{
		Jelly.Debug.Display_Error("Trying to remove input from action reference by namespace and alias, but no alias provided in element or in parameters");
		return;
	}
			
	// Remove input subreference from action reference.
	delete Action_Reference.Inputs[Input_Alias];
	
	// Remove element
	$(Input_Element).remove();

	if (Debug)
	{
		Jelly.Debug.End_Group("");
	}
};